import { API, UserRole, isSuperAdminRole } from "../../constants";
import { IInvoiceListItem } from "./invoices.api.types";

export const buildInvoiceListUrl = (
  range: { startDate: string; endDate: string },
  userInfo: any
): string => {
  const isSuperAdmin = isSuperAdminRole(userInfo?.["custom:roleName"]);
  const scopedFetchDisabled = localStorage.getItem("disableScopedFetch") !== null;
  const vendorId =
    API.INVOICE.VENDOR_SCOPED_INVOICES && !isSuperAdmin && !scopedFetchDisabled
      ? userInfo?.["cognito:username"]
      : undefined;
  return API.INVOICE.buildBedrockListUrl({ ...range, vendorId });
};

export const isHotelInvoice = (invoice: IInvoiceListItem): boolean =>
  invoice.vendorType === "Hotel" || !!invoice.vendorCode?.trim();

const CLIENT_SIDE_INVOICE_SCOPING = false;

const SUPER_ADMIN_VISIBLE_VENDOR_IDS: string[] = [
  "c468c4d8-8001-700a-e98c-8e64ec76af34",
  "c4e8c428-4031-700c-cc32-e7196e7fc04f",
  "d42884a8-30b1-70c0-5d9c-86cb42cbe887",
  "d468c468-8031-70be-469d-6fa5776c37df",
  "b44834c8-c071-7046-eb88-afad33d34a4e",
  "d4284418-4071-705e-d96c-5e43ac44dc03",
  "e418a438-a041-7041-2dc4-aee7128a6f56",
  "e4486418-a071-705f-b758-dc0dc002d115",
  "9468c4f8-b041-7065-2542-fee60026f9d6",
  "94a83458-0011-7012-2a0f-f35b85c95764",
  "24987408-80f1-70c2-2855-e3147540b8f7",
  "24a874e8-5071-7063-501f-b06d20b46df4",
  "44680478-8051-7097-467e-f801b7c379da",
  "d4f8e418-d001-7011-0cf8-db09cd3b797d",
];

export const scopeInvoicesForUser = (
  items: IInvoiceListItem[],
  userInfo: any
): IInvoiceListItem[] => {
  const isSuperAdmin = userInfo?.["custom:roleName"] === UserRole.SUPER_ADMIN;
  if (isSuperAdmin) {
    return items.filter((invoice) =>
      SUPER_ADMIN_VISIBLE_VENDOR_IDS.includes(
        String(invoice.vendorId).toLowerCase()
      )
    );
  }
  if (!CLIENT_SIDE_INVOICE_SCOPING) return items;

  const myVendorId = userInfo?.["cognito:username"];
  return items.filter((invoice) => String(invoice.vendorId) === String(myVendorId));
};
